"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfModelError = instanceOfModelError;
exports.ModelErrorFromJSON = ModelErrorFromJSON;
exports.ModelErrorFromJSONTyped = ModelErrorFromJSONTyped;
exports.ModelErrorToJSON = ModelErrorToJSON;
/**
 * Check if a given object implements the ModelError interface.
 */
function instanceOfModelError(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ModelErrorFromJSON(json) {
    return ModelErrorFromJSONTyped(json, false);
}
function ModelErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function ModelErrorToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
